import { render } from "./FansRankingWeeklyTabCont.vue?vue&type=template&id=23d4998d"
import script from "./FansRankingWeeklyTabCont.vue?vue&type=script&lang=js"
export * from "./FansRankingWeeklyTabCont.vue?vue&type=script&lang=js"

import "./FansRankingWeeklyTabCont.vue?vue&type=style&index=0&id=23d4998d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__